import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* fetchFolders(action: actionsInterfaces.IFetchFoldersAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);

    let callUrl = `${host}folders` ;   
    if (action.query) callUrl = `${host}folders${action.query}`;

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.folders.setFolders(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getFolder(action: actionsInterfaces.IFetchFolderAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);

    let callUrl = `${host}folders` ;   
    if (action.query) callUrl = `${host}folders${action.query}`;
    
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.folders.setFolder(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addFolder(action: actionsInterfaces.IPostFolderAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}folders`, action.folder,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.folders.setFolder([action.folder] as any));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateFolder(action: actionsInterfaces.IUpdateFolderAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}folders/${action.folder.id}`,action.folder,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.folders.setFolder([action.folder] as any));
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.FETCH_FOLDERS, fetchFolders),
    takeLatest(actionsTypes.GET_FOLDER, getFolder),
    takeEvery(actionsTypes.ADD_FOLDER, addFolder),
    takeEvery(actionsTypes.UPDATE_FOLDER, updateFolder)
  ])
}

